var codeblock_default = {
  "blockStyleSpacing": "r5d6J",
  "codeBlock": "XC9vs r5d6J",
  "renderedInTable": "JGxEl"
};
export {
  codeblock_default as default
};
//# sourceMappingURL=codeblock-scss.js.map
